/* eslint-disable no-console */
/* eslint-disable max-len */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { LanguageContext } from '../../../../libs/Context';
import { MediaContext } from '../..';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { Button, Table, TableBody, TableContainer } from '@mui/material';
import BreadCrumbComponent from '../../Common/BreadCrumbs';
import NoData from '../../../../components/Common/NoData';
import MediaKitLoader from '../../../../components/Common/Shimmer/MediaKitShimmer';
import MediakitCardShimmer from '../../../../components/Common/Shimmer/MediaKitShimmer/MediaKitCardShimmer';
import MediaKitTableHead from './components/TableHeader/TableHead';
import MediaKitTableToolbar from './components/TableHeader/TableToolbar';
import ListCard from './components/ListCard';
import GridCard from './components/GridCard';
import ShareFilePopup from '../../popups/ShareFilePopup';
import ZippedFiles from './components/ZippedPopUp';
import useDebounce from '../../../../components/Hooks/useDebounce';
import useGetSharedItems from '../../customHooks/useGetSharedItems';
import useGetMyFolders from '../../customHooks/useGetMyFolder';
import useGetEmployeList from '../../customHooks/useGetEmployeList';
import useFetchTrash from '../../customHooks/useFetchTrash';
import Loading from '../../../../components/Common/Loaders/FullWidthLoader/Loading';
import Preview from '../../Common/Priview';
import useCustomTemplate from '../../customHooks/useCustomTemplare';
import NoDataImage from '../../../../assets/NoDataImages/notFound_img.svg';

const ListGridViews = (props:any) =>
{
	const { userData } = props;
	const { mediaState, setMediaState, tab, creatLoading } = useContext(MediaContext);
	const { language } = useContext(LanguageContext);
	const { folderData, sharedData, employeeData, trashData, myTemplateData } = useSelector((state:any) => state?.mymediakit?.mediaKitData);
	const visibleFolderData = tab === 0 ? folderData : tab === 1 ? sharedData : tab === 2 ? employeeData : tab === 3 ? trashData : myTemplateData;
	const debounceSearchTerm = useDebounce(mediaState?.searchValue, 500);
	const getFoldersData = useGetMyFolders({ debounceSearchTerm });
	const getTemplatesData = useCustomTemplate({ debounceSearchTerm });
	const getSharedList = useGetSharedItems(mediaState, setMediaState);
	const getEmployeList = useGetEmployeList();
	const getTrashDataInfo = useFetchTrash();
	const navigate = useNavigate();
	const [ shareFiles, setShareFiles ] = useState<any>({ open: false, data: {} });
	const folderId = useParams()?.id || '';
	const userId = useParams()?.userId || '';
	const tabVal = useParams()?.tab;
	const { downloadFile, zipFile } = useSelector((state:any) => state.mymediakit);
	const clickedUser = useParams()?.userId || '';
	const [ previewOpen, setPreviewOpen ] = useState<any>({ open: false, data: {} });
	const [ empData, setEmpData ] = useState<any>({});
	const lastFileElement = useRef(null);

	const LoadMore = () =>
	{
		const currentCountVal = {
			0 : mediaState?.count?.myFolders,
			1 : mediaState?.count?.sharedItems,
			2 : mediaState?.count?.employee,
			3 : mediaState?.count?.trash,
			4 : mediaState?.count?.myTemplates
		};

		if ((currentCountVal[tab]) > visibleFolderData?.length)
		{
			setMediaState({ type: 'updateReducer', payload: { page: mediaState?.page + 1 } });
		}
	};

	useEffect(() =>
	{
		if (mediaState?.allSelected)
		{
			setMediaState({ type: 'updateReducer', payload: { selectedData: [ ...visibleFolderData ] } });
		}
	}, [ folderData, sharedData, employeeData, trashData ]);

	const handleClickFolder = (data:any) =>
	{
		data?.type === 0 && setMediaState({ type: 'updateReducer', payload: { page: 0, searchValue: '', selectedData: [], allSelected: false, loading: true } });

		const extensionformat = data?.media && data?.media?.key?.split('.').pop();
		const documentCheck = [ 'doc', 'pdf', 'docx', 'ppt', 'pptx', 'xls', 'odt', 'ods', 'odp', 'rtf', 'txt' ];

		if (tab === 2 && (data?.type ? data?.type === 0 : true))
		{
			if (data?.folderId)
			{
				navigate(`/drive/empF/${tabVal}/${clickedUser}/${data?.folderId}`);
			}
			else
			{
				setMediaState({ type: 'updateReducer', payload: { page: 0, searchValue: '', selectedData: [], allSelected: false, loading: true } });
				setEmpData(data);
				navigate(`/drive/empF/${tabVal}/${data?.userId}`);
			}
		}
		else if ([ 0, 1, 2, 4 ]?.includes(tab))
		{
			if (data?.type === 0)
			{
				if (tab === 3) { return; }
				navigate(`/drive/${tabVal}/${data?.folderId}`);
			}
			else if (extensionformat !== 'zip' || documentCheck.includes(extensionformat))
			{
				setPreviewOpen({ open: true, data });
			}
		}
	};

	const handleCheckBox = (data:any) =>
	{
		const checkedData = Array.isArray(mediaState?.selectedData) ? [ ...mediaState.selectedData ] : [];
		const findIndex = checkedData?.findIndex((item:any) => item?.folderId === data?.folderId);

		if (findIndex === -1)
		{
			checkedData.push(data);
		}
		else
		{
			checkedData?.splice(findIndex, 1);
			setMediaState({ type: 'updateReducer', payload: { allSelected: false } });
		}
		setMediaState({ type: 'updateReducer', payload: { selectedData: checkedData } });
	};

	const openShare = (e, item) =>
	{
		setShareFiles({
			open : true,
			data : item
		});
	};

	const updateShareData = (data) =>
	{
		const shareToList = previewOpen?.data?.shareTo || [];

		const itemIndex = shareToList.findIndex((item) => item?.id === data?.id);

		let updatedShareTo;

		if (itemIndex !== -1)
		{
			updatedShareTo = shareToList.map((item) =>
				(item?.id === data?.id ? { ...item, ...data } : item)
			);
		}
		else
		{
			updatedShareTo = [ ...shareToList, data ];
		}

		setPreviewOpen({
			...previewOpen,
			data : {
				...previewOpen?.data,
				shareTo : updatedShareTo
			}
		});
	};

	console.log(previewOpen, '----shareFiles');

	const closeShare = () =>
	{
		setShareFiles({
			open : false,
			data : {}
		});
	};

	useEffect(() =>
	{
		if (tab === 2 && clickedUser !== '')
		{
			getFoldersData(mediaState?.filter);
		}
	}, [ clickedUser, mediaState?.page, folderId, debounceSearchTerm ]);

	useEffect(() =>
	{
		if (lastFileElement?.current)
		{
			const observer = new IntersectionObserver(
				([ entry ]) =>
				{
					if (entry.isIntersecting)
					{
						LoadMore();
					}
				},
				{
					root       : null,
					rootMargin : '0px',
					threshold  : 0.5
				}
			);

			if (lastFileElement.current)
			{
				observer.observe(lastFileElement.current);
			}

			return () =>
			{
				if (lastFileElement.current)
				{
					observer.unobserve(lastFileElement.current);
				}
			};
		}
	}, [ lastFileElement, mediaState?.count, visibleFolderData ]);

	useEffect(() =>
	{
		if (tab === 0 || (tab === 2 && userId))
		{
			getFoldersData(mediaState?.filter);
		}
		if (tab === 1)
		{
			getSharedList(mediaState?.filter);
		}
		if (tab === 2 && userData?.empRole === 'superAdmin' && clickedUser === '')
		{
			getEmployeList();
		}
		if (tab === 3)
		{
			getTrashDataInfo();
		}
		if (tab === 4)
		{
			getTemplatesData();
		}
	}, [ tab, mediaState?.page, mediaState?.sort, debounceSearchTerm, folderId, mediaState?.filter ]);
	const visibleCheckbox = (([ 0, 1, 3, 4 ]?.includes(tab) && mediaState?.selectedData?.length > 0) ||
	(tab === 2 && clickedUser !== '' && mediaState?.selectedData?.length > 0));
	const isSelected = mediaState?.selectedData.map((item) => item?.folderId);

	return (
		<div className='flexCol respdngHSM tableHeaderPositionSticky'>
			<div className='flexRow mediaBreadCrumbs alignCntr'>
				{!mediaState?.loading && (folderId || clickedUser) && <div className='flexMinWidthRow alignCntr pdngBSM breadCrumbAlign'>
					<BreadCrumbComponent childFileList={visibleFolderData} type={0} empData={empData} tab={tab} getEmployeList={getEmployeList}/>
				</div>}
			</div>
			{visibleCheckbox &&
			<MediaKitTableToolbar getTrashDataInfo={getTrashDataInfo} getFoldersData={getFoldersData}/>
			}
			{mediaState?.loading && (mediaState?.menuItems?.listGridview === 0 ? <MediaKitLoader/> : <MediakitCardShimmer />)}
			{!mediaState?.loading && visibleFolderData?.length > 0
				? <div className='flexCol'>
					<Box sx={{ width: 'var(--percent100)' }}>
						<Paper sx={{ width: 'var(--percent100)', md: 2 }}>
							<TableContainer sx={{ maxHeight : { xs : mediaState?.selectedData?.length > 0 ? 'var(--font200)' : '250px', // Extra-small screens
								sm : mediaState?.selectedData?.length > 0 ? '220px' : '270px', // Small screens
								md : mediaState?.selectedData?.length > 0 ? '240px' : '300px', // Medium screens
								lg : mediaState?.selectedData?.length > 0 ? 'var(--font280)' : '350px',
								xl : mediaState?.selectedData?.length > 0 ? 'calc(100vh - 326px)' : 'calc(100vh - 264px)'
							} }}
							>
								<Table stickyHeader aria-label='sticky table' className='positionSticky'>
									<MediaKitTableHead visibleFolderData={visibleFolderData}/>
								</Table>
								{creatLoading && <Loading/>}
								{mediaState?.menuItems?.listGridview === 0
									? <Table aria-label='tableTitle'>
										<TableBody>
											{visibleFolderData?.length > 0 && visibleFolderData?.map((item:any, index) =>
												(
													<>
														<ListCard
															key={`${item?.folderId}`}
															data={item}
															handleClickFolder={handleClickFolder}
															handleCheckBox={handleCheckBox}
															getFoldersData={getFoldersData}
															getTrashDataInfo={getTrashDataInfo}
															openShare={openShare}
															isSelected={isSelected}

														/>
														{(index === visibleFolderData?.length - 2) && <span ref={lastFileElement} /> }
													</>

												)
											)}
										</TableBody>
									</Table>
									: (
										<div className='flexWrap respdngHXS'>
											{visibleFolderData?.length > 0 && visibleFolderData?.map((eachItem:any, index) =>
												(
													<GridCard
														data={eachItem}
														key={`${eachItem?.folderId}`}
														LoadMore={LoadMore}
														handleClickFolder={handleClickFolder}
														handleCheckBox={handleCheckBox}
														tab={tab}
														index={index}
														visibleFolderData={visibleFolderData}
														getFoldersData={getFoldersData}
														getTrashDataInfo={getTrashDataInfo}
														openShare={openShare}
														closeShare={closeShare}
														trashData={trashData}
														isSelected={isSelected}

													/>
												))
											}
										</div>
									)
								}
							</TableContainer>
						</Paper>
					</Box>
				</div>
				: !mediaState?.loading && <div className='flexCol vertcalHeight50 alignCntr justifyCntr'>
					{debounceSearchTerm === ''
						? <>
							<NoData
								data={[]} checkChangedDates searchVal={''} noDataHead={tab === 0 ? language?.thereIsNoItems : tab === 1 ? language?.therearenoshareditems : tab === 2 ? language?.noItemsFoundInEmployee : tab === 3 ? language?.noTrashDataFound : language?.thereIsNoTemplates} noDataPara={tab === 0 ? '' : tab === 4 ? language?.createMarketingTemplate : tab === 1 && language?.Thesharedfolderfileswillbeavailablehere}
								src1={NoDataImage}
							/>
							{tab === 4 && <div className='flexRow justifyCntr pdngTSM'>
								<Button variant='outlined' className='primaryTxt subHeadingSM upperCaseTxt pointer' disableElevation disableRipple disableFocusRipple onClick={() => navigate(folderId ? `/drive/design/${tabVal}/${folderId}` : `/drive/design/${tabVal}`)}><img src='/images/icons/editgrey.svg' alt='editBrush' className='imgAvatarXXS lightTxt mrgnRXS invertPrimary'/>{language?.createdesign}</Button>
							</div>}
						</>
						: (
							<NoData noDataHead={language?.noSearchFound}
								src={<span className='icon-no_search--1 nodatafont'><span className='path1' /><span className='path2' /><span className='path3' /><span className='path4' /><span className='path5' /><span className='path6' /><span className='path7' /><span className='path8' /><span className='path9' /><span className='path10' /><span className='path11' /><span className='path12' /><span className='path13' /><span className='path14' /><span className='path15' /><span className='path16' /><span className='path17' /></span>}
							/>
						)
					}
				</div>
			}
			{shareFiles?.open &&
			<ShareFilePopup key={JSON.stringify(shareFiles?.data)} closeShare={closeShare} shareFiles={shareFiles} shareToggle={openShare}
				setShareData={updateShareData}
			/>}
			{(downloadFile?.length + zipFile?.length) > 0 && <ZippedFiles setMediaState={setMediaState} />}
			{previewOpen?.open && <Preview data={previewOpen?.data} previewOpen={previewOpen?.data} setPreviewOpen={setPreviewOpen} openShare={openShare} tab={tab}/>}
		</div>

	);
};

export default ListGridViews;